// Palace Cell - displays mirrored data from qimenplotter.com
// NO CALCULATIONS - pure display of scraped data

function StemDisplay({ stem, showDetails = true }) {
  if (!stem) return <span className="cell-placeholder" />;
  const colorClass = stem.color === "red" ? "item-red" : "item-black";
  return (
    <div className={`stem-display ${colorClass}`}>
      <span className={`stem-chinese ${colorClass}`}>{stem.chinese}</span>
      {showDetails && (
        <>
          <span className="stem-pinyin">{stem.pinyin}</span>
          <span className="stem-element">{stem.yinyang} {stem.element}</span>
        </>
      )}
    </div>
  );
}

function HiddenStemDisplay({ hiddenStem }) {
  if (!hiddenStem) return null;
  const stemChar = typeof hiddenStem === 'string' ? hiddenStem : hiddenStem.chinese;
  if (!stemChar) return null;
  
  return (
    <div className="hidden-stem-marker">
      <span className="hidden-stem-chinese">{stemChar}</span>
    </div>
  );
}

function StarDisplay({ star }) {
  if (!star) return null;
  const colorClass = star.color === "red" ? "item-red" : "item-black";
  return (
    <div className={`star-display ${colorClass}`}>
      <span className={`star-chinese ${colorClass}`}>{star.chinese}</span>
      <span className="star-pinyin">{star.pinyin}</span>
      <span className="star-english">{star.english}</span>
    </div>
  );
}

function DoorDisplay({ door }) {
  if (!door) return null;
  const colorClass = door.color === "red" ? "item-red" : "item-black";
  return (
    <div className={`door-display ${colorClass}`}>
      <span className={`door-chinese ${colorClass}`}>{door.chinese}</span>
      <span className="door-pinyin">{door.pinyin}</span>
      <span className="door-english">{door.english}</span>
    </div>
  );
}

function DeityDisplay({ deity }) {
  if (!deity) return null;
  const colorClass = deity.color === "red" ? "item-red" : "item-black";
  return (
    <div className={`deity-display ${colorClass}`}>
      <span className={`deity-chinese ${colorClass}`}>{deity.chinese}</span>
      <span className="deity-pinyin">{deity.pinyin}</span>
      <span className="deity-english">{deity.english}</span>
    </div>
  );
}

export default function PalaceCell({ palace }) {
  if (!palace) return null;

  // Center palace
  if (palace.is_center) {
    return (
      <div className="palace-cell palace-center" data-testid={`palace-${palace.palace_number}`}>
        <div className="center-content">
          <div className="center-logo">QiMen</div>
          <div className="center-subtitle">Plotter</div>
        </div>
      </div>
    );
  }

  // Check for special markers
  const hasDE = palace.has_de;
  const hasSkyHorse = palace.has_skyhorse;
  const isDay = palace.is_day_stem;
  const isHour = palace.is_hour_stem;
  const jiaVisible = palace.jia_visible;
  const formation = palace.formation;

  return (
    <div
      className={`palace-cell ${hasDE ? "palace-void" : ""}`}
      data-testid={`palace-${palace.palace_number}`}
    >
      {/* Top Row: Heaven Stem (LEFT), Star (MIDDLE), Deity (RIGHT) */}
      <div className="palace-top">
        <div className="stem-with-hidden">
          {/* Day/Hour marker */}
          {isDay && <span className="day-hour-badge day-badge">日</span>}
          {isHour && <span className="day-hour-badge hour-badge">时</span>}
          
          <StemDisplay stem={palace.heaven_stem} />
        </div>
        <StarDisplay star={palace.star} />
        <DeityDisplay deity={palace.deity} />
      </div>

      {/* Middle Row: Formation text if any */}
      {formation && (
        <div className="palace-middle">
          <div className="formation-text">{formation}</div>
        </div>
      )}

      {/* Bottom Row: Earth Stem + Jia + Hidden (LEFT), Door (MIDDLE), Number (RIGHT) */}
      <div className="palace-bottom">
        <div className="stem-with-hidden">
          {/* Hidden stem - appears BEFORE earth stem */}
          <HiddenStemDisplay hiddenStem={palace.hidden_stem} />
          {/* Jia marker - appears next to earth stem */}
          {jiaVisible && <span className="jia-marker">甲</span>}
          <StemDisplay stem={palace.earth_stem} />
        </div>
        <DoorDisplay door={palace.door} />
        <div className="palace-number">{palace.palace_number}</div>
      </div>
    </div>
  );
}
